import styled from 'styled-components';

import Colors from '#/ssm-ui/colors';

export const ResendOTP = styled.div`
  color: ${Colors['text-clickable']};
  font-size: 12px;
  margin-top: 20px;
  :hover {
    cursor: pointer;
  }
`;
